const clamp = (min, val, max) => Math.min(Math.max(min, val), max);
var clamp_default = clamp;
export {
  clamp_default as default
};
//# sourceMappingURL=clamp.js.map